import(/* webpackMode: "eager" */ "/source/node_modules/.pnpm/next@14.2.32_@babel+core@7.28.0_@opentelemetry+api@1.9.0_@playwright+test@1.55.0_react-_843bea163275ed798a6e420989b160e4/node_modules/next/dist/shared/lib/lazy-dynamic/dynamic-bailout-to-csr.js");
;
import(/* webpackMode: "eager" */ "/source/node_modules/.pnpm/next@14.2.32_@babel+core@7.28.0_@opentelemetry+api@1.9.0_@playwright+test@1.55.0_react-_843bea163275ed798a6e420989b160e4/node_modules/next/dist/shared/lib/lazy-dynamic/preload-css.js");
;
import(/* webpackMode: "eager", webpackExports: ["ErrorBoundary"] */ "/source/node_modules/.pnpm/react-error-boundary@4.1.2_react@18.3.1/node_modules/react-error-boundary/dist/react-error-boundary.esm.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/source/src/app/cms/[pageCode]/pvModule.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/source/src/app/cms/common/BrandsBig/component/swiper.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/source/src/app/cms/common/BrandsSmall/component/swiper.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/source/src/app/cms/common/CategoryBig/component/swiper.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/source/src/app/cms/common/CategorySmall/component/swiper.tsx");
;
import(/* webpackMode: "eager" */ "/source/src/app/cms/common/CategorySmall/style.module.scss");
;
import(/* webpackMode: "eager" */ "/source/src/app/cms/common/CategoryBig/style.module.scss");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/source/src/app/cms/common/ClientLogicHandler.tsx");
;
import(/* webpackMode: "eager" */ "/source/src/app/cms/common/contentLand/content.tsx");
;
import(/* webpackMode: "eager" */ "/source/src/app/cms/common/index.scss");
;
import(/* webpackMode: "eager" */ "/source/src/app/cms/common/nothing/index.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["StockDialog"] */ "/source/src/app/cms/common/StockDialog.tsx");
;
import(/* webpackMode: "eager" */ "/source/src/app/cms/modules/product-pc-floor/components/swiper.tsx");
;
import(/* webpackMode: "eager" */ "/source/src/app/cms/modules/product-pc-floor/index.tsx");
;
import(/* webpackMode: "eager" */ "/source/src/app/cms/modules/uk-miniHome/index.tsx");
;
import(/* webpackMode: "eager" */ "/source/src/app/cms/modules/uk-pc-best-seller_V2/components/BestSellers.tsx");
;
import(/* webpackMode: "eager" */ "/source/src/app/cms/modules/uk-pc-best-seller_V3/components/SwiperComponent.tsx");
;
import(/* webpackMode: "eager" */ "/source/src/app/cms/modules/uk-pc-carousel-small/component/swiper.tsx");
;
import(/* webpackMode: "eager" */ "/source/src/app/cms/modules/uk-pc-carousel-small/component/useSwiperAutoplayWithInitialDelay.ts");
;
import(/* webpackMode: "eager" */ "/source/src/app/cms/modules/uk-pc-carousel-small/index.tsx");
;
import(/* webpackMode: "eager" */ "/source/src/app/cms/modules/uk-pc-coupon/components/CountdownBar.tsx");
;
import(/* webpackMode: "eager" */ "/source/src/app/cms/modules/uk-pc-coupon/components/CouponContent.tsx");
;
import(/* webpackMode: "eager" */ "/source/src/app/cms/modules/uk-pc-coupon/components/CouponList.tsx");
;
import(/* webpackMode: "eager" */ "/source/src/app/cms/modules/uk-pc-coupon/components/ScrollContainer.tsx");
;
import(/* webpackMode: "eager" */ "/source/src/app/cms/modules/uk-pc-coupon/icons/SVGScrollController.svg");
;
import(/* webpackMode: "eager" */ "/source/src/app/cms/modules/uk-pc-coupon/icons/WatermarkAllClaimed.svg");
;
import(/* webpackMode: "eager" */ "/source/src/app/cms/modules/uk-pc-coupon/icons/WatermarkCollected.svg");
;
import(/* webpackMode: "eager" */ "/source/src/app/cms/modules/uk-pc-coupon/icons/WatermarkEnded.svg");
;
import(/* webpackMode: "eager" */ "/source/src/app/cms/modules/uk-pc-coupon/icons/WatermarkNotStarted.svg");
;
import(/* webpackMode: "eager" */ "/source/src/app/cms/modules/uk-pc-flash-sales/index.tsx");
;
import(/* webpackMode: "eager" */ "/source/src/app/cms/modules/uk-pc-flash-sales/saleTips.tsx");
;
import(/* webpackMode: "eager" */ "/source/src/app/cms/modules/uk-pc-flash-sales/swiper.tsx");
;
import(/* webpackMode: "eager" */ "/source/src/app/cms/modules/uk-pc-happy-hour/index.tsx");
;
import(/* webpackMode: "eager" */ "/source/src/app/cms/modules/uk-pc-happy-hour/saleTips.tsx");
;
import(/* webpackMode: "eager" */ "/source/src/app/cms/modules/uk-pc-image-ads/component/swiper.tsx");
;
import(/* webpackMode: "eager" */ "/source/src/app/cms/modules/uk-pc-image/index.tsx");
;
import(/* webpackMode: "eager" */ "/source/src/app/cms/modules/uk-pc-newcomer_V2/index.tsx");
;
import(/* webpackMode: "eager" */ "/source/src/app/cms/modules/uk-pc-newcomer-gift/gift.tsx");
;
import(/* webpackMode: "eager" */ "/source/src/app/cms/modules/uk-pc-newcomer-land/index.tsx");
;
import(/* webpackMode: "eager" */ "/source/src/app/cms/modules/uk-pc-newcomer-land/src/components/productList.tsx");
;
import(/* webpackMode: "eager" */ "/source/src/app/cms/modules/uk-pc-popular-categoryV2/component/swiper.tsx");
;
import(/* webpackMode: "eager" */ "/source/src/app/cms/modules/uk-pc-popular-categoryV2/style.module.scss");
;
import(/* webpackMode: "eager" */ "/source/src/app/cms/modules/uk-pc-newcomer_V2/style.module.scss");
;
import(/* webpackMode: "eager" */ "/source/src/app/cms/modules/uk-pc-newcomer-land/style.module.scss");
;
import(/* webpackMode: "eager" */ "/source/src/app/cms/modules/uk-pc-newcomer-gift/style.module.scss");
;
import(/* webpackMode: "eager" */ "/source/src/app/cms/modules/uk-pc-image/style.module.scss");
;
import(/* webpackMode: "eager" */ "/source/src/app/cms/modules/uk-pc-image-ads/style.module.scss");
;
import(/* webpackMode: "eager" */ "/source/src/app/cms/modules/uk-pc-hotspot/style.scss");
;
import(/* webpackMode: "eager" */ "/source/src/app/cms/modules/uk-pc-happy-hour/tips.module.scss");
;
import(/* webpackMode: "eager" */ "/source/src/app/cms/modules/uk-pc-happy-hour/style.module.scss");
;
import(/* webpackMode: "eager" */ "/source/src/app/cms/modules/uk-pc-flash-sales/tips.module.scss");
;
import(/* webpackMode: "eager" */ "/source/src/app/cms/modules/uk-pc-flash-sales/style.module.scss");
;
import(/* webpackMode: "eager" */ "/source/src/app/cms/modules/uk-pc-demo/style.module.scss");
;
import(/* webpackMode: "eager" */ "/source/src/app/cms/modules/uk-pc-delivery/style.module.scss");
;
import(/* webpackMode: "eager" */ "/source/src/app/cms/modules/uk-pc-coupon/style.scss");
;
import(/* webpackMode: "eager" */ "/source/src/app/cms/modules/uk-pc-coupon/components/ScrollContainer.scss");
;
import(/* webpackMode: "eager" */ "/source/src/app/cms/modules/uk-pc-coupon/components/CouponList.scss");
;
import(/* webpackMode: "eager" */ "/source/src/app/cms/modules/uk-pc-carousel-small/style.module.scss");
;
import(/* webpackMode: "eager" */ "/source/src/app/cms/modules/uk-pc-best-seller_V3/index.module.scss");
;
import(/* webpackMode: "eager" */ "/source/src/app/cms/modules/uk-pc-best-seller_V3/components/SwiperComponent.module.scss");
;
import(/* webpackMode: "eager" */ "/source/src/app/cms/modules/uk-miniHome/style.module.scss");
;
import(/* webpackMode: "eager" */ "/source/src/app/cms/modules/uk-pc-best-seller_V2/components/style.module.scss");
;
import(/* webpackMode: "eager" */ "/source/src/app/cms/common/BrandsSmall/style.module.scss");
;
import(/* webpackMode: "eager" */ "/source/src/app/cms/modules/product-pc-floor/style.module.scss");
;
import(/* webpackMode: "eager" */ "/source/src/app/cms/common/BrandsBig/style.module.scss");
;
import(/* webpackMode: "eager" */ "/source/src/app/cms/[pageCode]/cms.module.scss");
;
import(/* webpackMode: "eager", webpackExports: ["default","getInstance"] */ "/source/src/app/login/index.login.ts");
;
import(/* webpackMode: "eager", webpackExports: ["getEncryptDefaultString"] */ "/source/src/app/login/utils/index.ts");
;
import(/* webpackMode: "eager" */ "/source/src/assets/icons/chevron-down.svg");
;
import(/* webpackMode: "eager", webpackExports: ["ErrorTryAgain"] */ "/source/src/components/error.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/source/src/components/floatingToolbar/index.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/source/src/components/OchamaMigTrack.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/source/src/components/recommend/recommendClient.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/source/src/components/SafeLink.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["useTranslation"] */ "/source/src/i18n/client.ts");
